import { Component, OnInit, Output, OnDestroy, EventEmitter } from '@angular/core';
import { ModalService } from '@services/modal.service';

@Component({
  selector: 'app-modal-profile-success-change-password',
  templateUrl: './modal-profile-success-change-password.component.html',
  styleUrls: ['./modal-profile-success-change-password.component.scss']
})
export class ModalProfileSuccessChangePasswordComponent  implements OnDestroy {

  @Output() confirm: EventEmitter<object> = new EventEmitter();
  constructor(public modal: ModalService) {  }

    ngOnDestroy() {
      this.modal.close();
    }

    accept() {
      this.modal.close();
      this.confirm.emit();
    }

}